export default "__VITE_ASSET__DAPg$68j__"